import useTracker from '@hooks/useTracker';
import { CLICK_NEWS, SEARCH_NEWS } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventClickNews = (props) => {
    trackEvent(CLICK_NEWS, props);
  };

  const eventSearchNews = () => {
    trackEvent(SEARCH_NEWS);
  };

  return {
    eventClickNews,
    eventSearchNews,
  };
};

export default useEventTracker;
